import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'MANUTENCAO_PREVENTIVA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('manutencaoPreventivaForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/manutencaoPreventiva`);
    return {
        type: 'MANUTENCAO_PREVENTIVA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/manutencaoPreventiva`, {
                ...registro,
                data_manutencao: DateFormat.formatarDataTelaParaSql(registro.data_manutencao),
                km_atual: FormatUtils.formatarValorBanco(registro.km_atual, 0),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/manutencaoPreventiva`, {
                ...registro,
                data_manutencao: DateFormat.formatarDataTelaParaSql(registro.data_manutencao),
                km_atual: FormatUtils.formatarValorBanco(registro.km_atual, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/manutencaoPreventiva?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/manutencaoPreventivaTipo/listarSelect`);
    return {
        type: 'MANUTENCAO_PREVENTIVA_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'MANUTENCAO_PREVENTIVA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}
